export default __webpack_public_path__ + "static/media/cloud-computing.bc4e95a2.svg";